import { useQuery } from '@tanstack/react-query'
import request from 'api'

type SecurityPolicy = {
  mfa: boolean
}

interface PolicyResponse {
  security: SecurityPolicy
}

const needToHideMfaMenu = (confirmPasswordKey?: string) => {
  return request
    .get<PolicyResponse>('/v1/policies', { headers: { 'x-confirm-key': confirmPasswordKey } })
    .then((response) => {
      if (response.status !== 200) {
        throw new Error('fetching policy failed.')
      }
      return response.data
    })
    .then((policy) => {
      return !policy.security.mfa
    })
    .catch(() => {
      return false
    })
}

const useHidingMfaQuery = (confirmPasswordKey?: string) =>
  useQuery(['hideMFA'], () => {
    return needToHideMfaMenu(confirmPasswordKey)
  })

export default useHidingMfaQuery
